import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Header.css';

const Header = () => {
  const { currentUser, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const profileMenuRef = useRef(null);
  const mobileMenuRef = useRef(null);

  // Add click outside handler to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target) && !event.target.classList.contains('mobile-menu-toggle')) {
        setShowMobileMenu(false);
      }
    };

    // Add event listener when dropdown is open
    if (showProfileMenu || showMobileMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    // Clean up event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showProfileMenu, showMobileMenu]);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const toggleProfileMenu = () => {
    setShowProfileMenu(!showProfileMenu);
  };

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/">
              <img 
                src={process.env.PUBLIC_URL + '/images/aero-logo.jpg'} 
                alt="AeroIndustrialHub Logo" 
                className="logo-image"
              />
            </Link>
          </div>
          
          {/* Mobile menu toggle button */}
          <button 
            className="mobile-menu-toggle" 
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          
          <nav className={`main-nav ${showMobileMenu ? 'mobile-visible' : ''}`} ref={mobileMenuRef}>
            <ul>
              <li className="nav-item">
                <Link to="/aero-industrial-hub">Unit Booking</Link>
              </li>
              {isAuthenticated ? (
                <>
                  <li className="profile-menu-container" ref={profileMenuRef}>
                    <button 
                      className={`profile-menu-button ${showProfileMenu ? 'active' : ''}`} 
                      onClick={toggleProfileMenu}
                    >
                      {currentUser?.name || 'Profile'} <span className="dropdown-arrow">▼</span>
                    </button>
                    {showProfileMenu && (
                      <div className="profile-dropdown">
                        {currentUser?.role === 'agent_admin' ? (
                          <Link to="/agent-dashboard" onClick={() => setShowProfileMenu(false)}>Agent Panel</Link>
                        ) : currentUser?.role === 'super_admin' || currentUser?.role === 'admin' ? (
                          <Link to="/admin-dashboard" onClick={() => setShowProfileMenu(false)}>Admin Panel</Link>
                        ) : (
                          <Link to="/enhanced-dashboard" onClick={() => setShowProfileMenu(false)}>Dashboard</Link>
                        )}
                        <button className="dropdown-logout-btn" onClick={handleLogout}>
                          Logout
                        </button>
                      </div>
                    )}
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item">
                    <Link to="/login">Login</Link>
                  </li>
                </>
              )}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
